import { useApolloClient, useQuery } from "@apollo/react-hooks";
import { useEffect, useState } from "react";
import {
  CONSULTORY_PARAMETERS_AND_ORDER,
  SPECIALITIES_BY_CONSULTORY_PARAMETERS,
  VALIDATE_USE_SPECIALITIES_IN_PARAMETERS,
} from "./queries";
import { uniqBy } from "lodash";
import { useToasts } from "react-toast-notifications";
const INITIAL_STATE = {
  data: [],
  modalIsOpenParameters: false,
  dataConsultoryParameters: [],
  searchByName: "",
  optionsSpecialitiesByMedical: [],
  activeTab: null,
};

export default function useActions(
  { medicalStaffId, branchOfficeId },
  history,
) {
  const [state, setState] = useState(INITIAL_STATE);
  const client = useApolloClient();
  const { addToast } = useToasts();

  console.log("MedicalParameters state", state);

  const {
    data: { consultoryParametersAndOrder } = {},
    loading: consultoryParametersAndOrderLoading,
  } = useQuery(CONSULTORY_PARAMETERS_AND_ORDER, {
    fetchPolicy: "network-only",
    skip: !state.activeTab,
    variables: {
      where: {
        specialtiesId: state.activeTab,
        medicalStaffId,
        branchOfficeId,
      },
    },
  });

  const {
    data: especialtiesByconsultoryParameters,
    loading: especialtiesByconsultoryParametersLoading,
  } = useQuery(SPECIALITIES_BY_CONSULTORY_PARAMETERS, {
    fetchPolicy: "network-only",
    variables: {
      relations: ["specialty"],
      where: { medicalStaffId, branchOfficeId },
    },
  });

  console.log("state component main", state);

  const onChange = (key, value) => {
    setState((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleActionButtonAdd = async () => {
    const { data: { validateUseSpecialitiesInParameters } = {} } =
      (await client.query({
        fetchPolicy: "network-only",
        query: VALIDATE_USE_SPECIALITIES_IN_PARAMETERS,
        variables: {
          where: {
            branchOfficeId,
            medicalStaffId,
          },
        },
      })) ?? {};

    console.log(validateUseSpecialitiesInParameters);

    if (!validateUseSpecialitiesInParameters)
      return addToast(
        "No existen parámetros adicionales para asignar a sus especialidades. ",
        {
          appearance: "error",
          autoDismiss: true,
        },
      );

    history.push(`/medical-parameters/create`);
  };

  const toggle = () => {
    onChange("modalIsOpenParameters", false);
  };

  useEffect(() => {
    if (
      especialtiesByconsultoryParameters &&
      !especialtiesByconsultoryParametersLoading
    ) {
      const dataSpecialties =
        especialtiesByconsultoryParameters?.consultoryParameters?.map(
          (item) => item.specialty,
        ) || [];

      const dataSpecialitiesUniq = uniqBy(dataSpecialties, "id");

      setState((prev) => ({
        ...prev,
        optionsSpecialitiesByMedical: dataSpecialitiesUniq,
        activeTab: dataSpecialitiesUniq[0]?.id,
      }));
    }
  }, [
    especialtiesByconsultoryParameters,
    especialtiesByconsultoryParametersLoading,
  ]);

  useEffect(() => {
    if (consultoryParametersAndOrder && !consultoryParametersAndOrderLoading) {
      setState((prev) => ({
        ...prev,
        dataConsultoryParameters: consultoryParametersAndOrder,
      }));
    }
  }, [consultoryParametersAndOrder, consultoryParametersAndOrderLoading]);

  return [
    { state },
    {
      onChange,
      toggle,
      consultoryParametersAndOrderLoading,
      handleActionButtonAdd,
    },
  ];
}
